import { jsx, Fragment } from 'react/jsx-runtime';
import { isBrowser } from '@websolutespa/bom-core';
import { useEffect } from 'react';
import { v4 } from 'uuid';
import { useLlm } from '../../../useLlm/useLlm.js';

const Font = () => {
  var _a;
  const theme = useLlm(state => state.theme);
  useEffect(() => {
    var _a;
    if (isBrowser) {
      const head = document.querySelector('head');
      if (head) {
        const fontId = v4();
        const htmlText = ((_a = theme.font) === null || _a === void 0 ? void 0 : _a.source) || `
<link rel="stylesheet" href="https://design.wslabs.it/llm/fonts/aeonik.css">
<link rel="stylesheet" href="https://design.wslabs.it/llm/fonts/capraia.css">
        `;
        const parser = new DOMParser();
        const parsedDocument = parser.parseFromString(htmlText, 'text/html');
        const nodes = Array.from(parsedDocument.querySelectorAll('head>*'));
        const selector = `llm-font-${fontId}`;
        nodes.forEach(node => {
          node.classList.add(selector);
          head.appendChild(node);
          console.log('[mixer-llm] added font node', node);
        });
        return () => {
          const addedNodes = Array.from(document.querySelectorAll(`.${selector}`));
          addedNodes.forEach(node => {
            if (node.parentNode) {
              node.parentNode.removeChild(node);
              console.log('[mixer-llm] removed font node', node);
            }
          });
        };
      }
    }
    return () => {};
  }, [(_a = theme.font) === null || _a === void 0 ? void 0 : _a.source]);
  return jsx(Fragment, {});
};
function getSeed(text, length) {
  if (length === void 0) {
    length = 32;
  }
  let seed = '';
  for (let i = 0; i < text.length; i++) {
    if (seed.length < length) {
      seed += text.charCodeAt(i).toString(16);
    }
  }
  return seed.padEnd(length, '0');
}

export { Font, getSeed };
//# sourceMappingURL=font.js.map
